import React, { createContext, useContext, useMemo } from 'react';
import useAffordaPortalDetailsQuery from 'hooks/queries/useAffordaPortalDetailsQuery';

// Create context for AffordaPortalDetails
export const AffordaPortalDetailsContext = createContext(null);

// Custom hook to consume context
export const useAffordaPortalDetailsContext = () => {
  const context = useContext(AffordaPortalDetailsContext);

  if (!context) {
    throw new Error(
      'useAffordaPortalDetailsContext must be used within an AffordaPortalDetailsProvider',
    );
  }

  return context;
};

// Provider for the AffordaPortalDetails context
export const AffordaPortalDetailsProvider = ({ children }) => {
  const {
    data: affordaPortalDetails,
    isLoading,
    error,
    refetch,
  } = useAffordaPortalDetailsQuery();

  const value = useMemo(() => {
    return {
      affordaPortalDetails,
      isLoading,
      error,
      refetch,
    };
  }, [affordaPortalDetails, isLoading, error, refetch]);

  return (
    <AffordaPortalDetailsContext.Provider value={value}>
      {children}
    </AffordaPortalDetailsContext.Provider>
  );
};
